import React, { useEffect, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { loadModules } from "esri-loader";
import { UrlServices, UrlServicesTypeTrasnporte, UrlServicesTypeTrasnporteName, UrlServicesNode, UrlServicesfilterNode, createRequestURLs } from "../../../../.config";
import dateFormat from "dateformat";
import { BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import { RiCheckboxCircleFill } from "react-icons/ri";
import Button from 'react-bootstrap/Button';
import { TODIS_FORM_FIELD_MULTISELECT,TODIS_FORM_FIELD_TEXT,TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD, TODIS_FORM_DSC, TODIS_FORM_FIELD_DATE, TODIS_FORM_FIELD_DATE_YEAR, TODIS_FORM_FIELD_DATE_RQ, TODIS_FORM_FIELD_OPTIONS_GDB, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE } from "../../../../components/Forms";
import { AuxiliaryService } from '../../../../HttpService/AuxiliaryService';
import { Formik, Field, Form, ErrorMessage, useFormik } from 'formik';
import "../../../DataCollection/style.css";
import { TODIS_MODAL } from "../../../../components/Modals/Modal";
import { TODIS_TASK, TASK,EU_ACQUIS , TODIS_EU_ACQUIS} from "../../../../.config/form/network_performance";
import style from "../Requests.module.scss";
import { RequestService } from "../../../../HttpService/RequestService";
import Swal from 'sweetalert2'
// import { loadModules } from "esri-loader";

const EuAcquisFormRequest = (props) => {

    const [tasks, setTasks] = useState([]);
    const [transports, setTransports] = useState([]);

    const [regionals, setRegionals] = useState([]);

    const [personals, setPersonals] = useState([
        {
            idAuxtabledetail: "john.doe",
            txtDescription: "John Doe"
        }
    ]);

    const [sectors,setSectors] = useState([]);
    const [regulatoryAreas,setRegulatoryAreas] = useState([]);
    const [typeOfActs,setTypeOfActs] = useState([]);
    const [actionPlans, setActionPlans] = useState([]);

    const getDataSelect = async () => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/euacquis,regulatoryarea,regionalpartner,actionplans,euacquitype").getAuxiliaries();

            auxiliaries.map(item => {
                if (item.txtNameTable == "typeform")
                    setTasks(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "euacquis")
                    setSectors(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "regionalpartner") {
                    let list = item.auxtableDetailsDTOList.sort((a, b) =>
                        a.txtDescription.localeCompare(b.txtDescription));
                    setRegionals(list)
                }
                if (item.txtNameTable == "regulatoryarea")
                    setRegulatoryAreas(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "actionplans")
                    setActionPlans(item.auxtableDetailsDTOList);
                if(item.txtNameTable == "euacquitype")
                    setTypeOfActs(item.auxtableDetailsDTOList);
            })

            getRegionalUsers();
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRegionalUsers = async () => {

        let users = await new RequestService("workflow/request/regionals").get();
        console.log('loaded users', users);
        let persons = users.map((itm) => {
            return {
                "idAuxtabledetail": itm.username,
                "txtDescription": itm.first_name + " " + itm.last_name
            }
        });
        //console.log("persons data", persons)
        if( users)
            setPersonals(persons);
    }


    useEffect(() => {
        getDataSelect();
    }, []);
    
    const [modalShow, setModalShow] = useState(false);


    

    const onSubmit = async (values, { resetForm }) => {
        const loadingSwal = Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            //showCancelButton: true,
            //cancelButtonText: 'Close',
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            //values.validFrom = dateFormat(values.validFrom, "yyyy-mm-dd");
            //values.validTo = dateFormat(values.validTo, "yyyy-mm-dd");
            let validFor = values.validFrom.year.toString();
            let sector = parseInt(values.sector);
            let regulatoryArea = parseInt(values.regulatoryArea);
            let actionPlan = parseInt(values.actionPlan);
            let typeOfAct = parseInt(values.typeOfAct);

            // let startNodeName = values.startKm.toString();
            // let endNodeName = values.endKm.toString();
            
            //console.log("data Form", values);
            let regionalPartners = values.regionalPartnar.map((partner)=> {return partner.value})
            const res = await new RequestService("workflow/request/euacquis").createRequest({ ...values,regionalPartnar: regionalPartners, validFrom:validFor,sector,regulatoryArea,actionPlan,typeOfAct });
            // console.log("data Form", values);
            // const res = await new RequestService("workflow/request").createRequest({ ...values, name: "Data Collection" });
            if (res.status > 200 && res.status < 300) {
                Swal.close();
                resetForm();
                props.onHide()
                props.pushRequest()
                setModalShow(true);
            } else {
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'An unexpected error occurred while creating the update request.',
                    showConfirmButton: true
                });
                console.log("error in create Task", res);
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred while creating the update request.',
                showConfirmButton: true
            });
            console.log("error in create Task", error);
        }
    }
    return (
        <Container fluid className="todis-form-wrapper p-3" style={{ height: "100%" }}>
            <Row>
                <Formik
                    initialValues={EU_ACQUIS}
                    validationSchema={TODIS_EU_ACQUIS}
                    onSubmit={onSubmit}>
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form className="todis-form-content p-0">
                            <Container>
                                <Row>

                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_MULTISELECT id="regionalPartnar"  label="REGIONAL PARTNER" name="regionalPartnar" setFieldValue={setFieldValue} values={values} isLoading={false} options={regionals} />
                                        {errors.regionalPartnar && touched.regionalPartnar ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.regionalPartnar}</div>) : null}
                                    </Col>

                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_TEXT id="celexNumber" label="CELEX NUMBER" name="celexNumber" type="text" />
                                        {errors.celexNumber && touched.celexNumber ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.celexNumber}</div>) : null}
                                    </Col>
                                    <Col lg={12}>
                                        <TODIS_FORM_DSC id="legalAct" label="LEGAL ACT" name="legalAct" text="" style={{ height: "auto" }} />
                                        {errors.legalAct && touched.legalAct ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.legalAct}</div>) : null}
                                    </Col>

                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="sector" label="SECTOR" name="sector" type="select" options={sectors} />
                                        {errors.sector && touched.sector ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.sector}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="regulatoryArea" label="REGULATORY AREA" name="regulatoryArea" type="select" options={regulatoryAreas} />
                                        {errors.regulatoryArea && touched.regulatoryArea ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.regulatoryArea}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="typeOfAct" label="TYPE OF ACT" name="typeOfAct" type="select" options={typeOfActs} />
                                        {errors.typeOfAct && touched.typeOfAct ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.typeOfAct}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="actionPlan" label="ACTION PLAN" name="actionPlan" type="select" options={actionPlans} />
                                        {errors.actionPlan && touched.actionPlan ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.actionPlan}</div>) : null}
                                    </Col>
                                    
                                    {/* <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="assignedTo" label="ASSIGNED TO" name="assignedTo" type="select" options={personals} />
                                        {errors.assignedTo && touched.assignedTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.assignedTo}</div>) : null}
                                    </Col> */}
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_DATE_YEAR id="validFrom" label="YEAR" name="validFrom" setFieldValue={setFieldValue} />
                                        {errors.validFrom && touched.validFrom ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validFrom}</div>) : null}
                                    </Col>
                                    <Col lg={12}>
                                        <TODIS_FORM_DSC id="description" label="DESCRIPTION" name="description" text="" style={{ height: "auto" }}></TODIS_FORM_DSC>
                                        {errors.description && touched.description ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.description}</div>) : null}
                                    </Col>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{ margin: "0.5rem" }}><BsPlusLg className="me-3" />CREATE REQUEST </Button>
                                    </div>
                                </Row>
                            </Container>

                            <TODIS_MODAL show={modalShow} onHide={() => setModalShow(false)} title="Creating Task" bodyText="Task has been created" iconBody={RiCheckboxCircleFill} />
                        </Form>
                    )}
                </Formik>
            </Row>
        </Container>
    );
}

export default EuAcquisFormRequest;